export default __webpack_public_path__ + "static/media/CLY.daba16ce.png";